'use client';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { MultiColumnSelector } from '../ColumnSelector';
import { useNodeInputColumns } from '../../../hooks/useNodeInputs';

interface DiffConfigProps {
  nodeId: string;
  config: { keyColumns?: string[]; compareColumns?: string[] };
}

export function DiffConfig({ nodeId, config }: DiffConfigProps) {
  const { t } = useTranslation();
  const { updateNodeConfig } = useWorkflowStore();
  const [keyColumns, setKeyColumns]         = useState<string[]>(config.keyColumns     || []);
  const [compareColumns, setCompareColumns] = useState<string[]>(config.compareColumns || []);
  // 合并两个输入节点的列（差异比较取左表字段作为选择依据）
  const inputColumns = useNodeInputColumns(nodeId, 0);

  // 当 config 变化时（如 AI 生成工作流后），同步更新内部状态
  useEffect(() => {
    if (config.keyColumns) {
      setKeyColumns(config.keyColumns);
    }
    if (config.compareColumns) {
      setCompareColumns(config.compareColumns);
    }
  }, [config.keyColumns, config.compareColumns]);

  const save = (updates: Partial<typeof config>) => {
    updateNodeConfig(nodeId, { type: 'diff', params: { keyColumns, compareColumns, ...updates } });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-xs font-medium text-zinc-500">{t('nodes.config.diff.keyColumns')}</label>
        <MultiColumnSelector values={keyColumns}
          onChange={(cols) => { setKeyColumns(cols); save({ keyColumns: cols }); }}
          columns={inputColumns ?? []}
        />
      </div>
      <div className="space-y-2">
        <label className="text-xs font-medium text-zinc-500">{t('nodes.config.diff.compareNode')}</label>
        <MultiColumnSelector values={compareColumns}
          onChange={(cols) => { setCompareColumns(cols); save({ compareColumns: cols }); }}
          columns={inputColumns ?? []}
        />
      </div>
    </div>
  );
}
